import React, { useEffect } from 'react';
import { RenderEngine, AvatarLoader, AnimationController, EventSyncAdapter } from '../avatarRenderingEngine';

// Placeholder Avaturn GLTF URL (replace with dynamic URL later)
const AVATURN_GLTF_URL = '/assets/models/my_avatar.glb';

const AvatarViewer = ({ eventBus }) => {
  useEffect(() => {
    console.log('[AvatarViewer] Component mounted');
    const container = document.getElementById('avatar-canvas');
    
    if (!container) {
      console.error('[AvatarViewer] Avatar canvas container not found');
      return;
    }
    
    console.log('[AvatarViewer] Container found, dimensions:', container.clientWidth, 'x', container.clientHeight);

    // Initialize renderer
    console.log('[AvatarViewer] Initializing renderer');
    const renderer = RenderEngine.initRenderer(container, {
      cameraSettings: { fov: 45, near: 0.1, far: 1000, position: [0, 1.6, 3] },
      lighting: { type: 'default' },
    });
    console.log('[AvatarViewer] Renderer initialized:', !!renderer);

    // Load avatar model
    console.log('[AvatarViewer] Starting avatar load from URL:', AVATURN_GLTF_URL);
    AvatarLoader.loadAvatar('avaturn_placeholder', {
      format: 'GLTF',
      sourceUrl: AVATURN_GLTF_URL,
      useCache: true,
    }).then((avatarModel) => {
      console.log('[AvatarViewer] Avatar loaded successfully:', avatarModel);
      console.log('[AvatarViewer] Adding avatar to scene');
      RenderEngine.addAvatarToScene(avatarModel);
      console.log('[AvatarViewer] Initializing animations');
      AnimationController.initializeAnimations(avatarModel, []);
      console.log('[AvatarViewer] Subscribing to events');
      EventSyncAdapter.subscribeToEvents(eventBus, avatarModel);
      console.log('[AvatarViewer] Avatar setup complete');
      console.log('[AvatarViewer] Avatar scene graph:', avatarModel.scene);
    }).catch((err) => {
      console.error('[AvatarViewer] Failed to load avatar:', err);
      console.error('[AvatarViewer] Error details:', err.message, err.stack);
    });

    return () => {
      // Cleanup logic if needed
    };
  }, [eventBus]);

  return null; // No React DOM output, renders to canvas directly
};

export default AvatarViewer;